var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 196,
    viewBox: "0 0 259 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_29241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.189 186.5C215.293 172.396 224.83 155.859 228.722 136.296C232.613 116.734 230.616 96.4563 222.983 78.0286C215.35 59.6009 202.424 43.8505 185.839 32.7691C169.255 21.6877 149.757 15.773 129.811 15.773C109.865 15.773 90.3665 21.6877 73.782 32.7691C57.1975 43.8505 44.2714 59.6009 36.6384 78.0286C29.0054 96.4563 27.0082 116.734 30.8995 136.296C34.7908 155.859 44.5855 172.396 58.6895 186.5L129.811 186.5L201.189 186.5Z",
    fill: "#F7F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.859 167.337C190.837 157.36 197.631 144.648 200.384 130.81C203.137 116.971 201.724 102.626 196.324 89.5905C190.924 76.5546 181.781 65.4127 170.049 57.5736C158.317 49.7345 144.523 45.5505 130.414 45.5505C116.304 45.5505 102.51 49.7345 90.7785 57.5736C79.0465 65.4127 69.9025 76.5546 64.5029 89.5905C59.1033 102.626 57.6905 116.971 60.4432 130.81C63.1959 144.648 69.9905 157.36 79.9677 167.337L130.414 166.324L180.859 167.337Z",
    fill: "#E6E8EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3334,
    y: 72,
    width: 98.1392,
    height: 114.36,
    rx: 3,
    fill: "white",
    stroke: "#250056",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.2612,
    y1: 186.36,
    x2: 230.544,
    y2: 186.36,
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.365 49.495C179.365 51.7143 177.569 53.5105 175.358 53.5105C173.147 53.5105 171.351 51.7143 171.351 49.495C171.351 47.2757 173.147 45.4795 175.358 45.4795C177.569 45.4795 179.365 47.2757 179.365 49.495Z",
    stroke: "#9747FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2037 156.325C64.2037 157.16 63.5289 157.833 62.7002 157.833C61.8715 157.833 61.1967 157.16 61.1967 156.325C61.1967 155.491 61.8715 154.818 62.7002 154.818C63.5289 154.818 64.2037 155.491 64.2037 156.325Z",
    stroke: "#9747FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.38 114.697L195.528 114.14L197.584 111.687L198.14 114.841L200.588 116.9L197.44 117.457L195.384 119.909L194.828 116.756L192.38 114.697Z",
    fill: "#3ADEA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89 39.8284L101.26 35.575L98.8166 32.077L103.063 32.4478L106.555 30L106.185 34.2533L108.628 37.7514L104.382 37.3805L100.89 39.8284Z",
    fill: "#3ADEA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.699 116L122.699 121.5",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.699 116L117.199 121.5",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.699 116L143.699 121.5",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.699 116L138.199 121.5",
    stroke: "#250056",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.779 86.4829L96.0908 90.3566L81.0007 85.5",
    stroke: "#250056",
    strokeWidth: 1.63633,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2168 73L92.1135 80.6939L98.1876 81.5649L100.847 86.0788L106.111 86.8336L108.134 90.0166",
    stroke: "#250056",
    strokeWidth: 1.63633,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.09 154L163.987 161.694L170.061 162.565L172.72 167.079L177.984 167.834L179.5 171.5",
    stroke: "#250056",
    strokeWidth: 1.63633,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 175L88.4172 176.034L89.5129 169.996L98.5 167",
    stroke: "#250056",
    strokeWidth: 1.63633,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_29241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259,
    height: 196,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFace);
export default __webpack_public_path__ + "static/media/error-face.bdadeaff5870d380a38448be4801b8b3.svg";
export { ForwardRef as ReactComponent };